// material-ui
import {Box, Button, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Typography} from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import {useNavigate, useParams} from "react-router";
import {useEffect, useState} from "react";
import axios from "axios";
import SkeletonPopularCard from 'ui-component/cards/Skeleton/PopularCard';
import Delete from "@mui/icons-material/Delete";
import Add from "@mui/icons-material/Add";
import AnimateButton from "../../ui-component/extended/AnimateButton";
import {DragDropContext, Draggable, Droppable} from 'react-beautiful-dnd';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

// ==============================|| SAMPLE PAGE ||============================== //

const PromptPage = () => {
    const {id} = useParams();
    const [loading, setLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [data, setData] = useState({})
    const [prompts, setPrompts] = useState([])
    const [prompt, setPrompt] = useState()
    const navigate = useNavigate();
    
    useEffect(() => {
        _getPrompt();
    }, [id]);

    
    function _getPrompt() {
        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                }
            }
            setLoading(true);
            const response = axios.get("/api/Prompt/get/" + id, config);
            response.then(x => {
                setLoading(false);
                setPrompt(null);
                setData(x.data);
                setPrompts(x.data.prompts)
            })
        } catch (error) {
            console.error("Save failed", error);
        }
    }

    const onDragEnd = (result) => {
        if (!result.destination) return; // dropped outside the list
        const items = Array.from(prompts);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setPrompts(items);
    };
    
    const handleUpdate =(e)=>{
        setIsSubmitting(true);
        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                }
            }
            const response = axios.put("/api/Prompt/UpdatePrompts/" + data.id,JSON.stringify(prompts), config);
            response.then(x => {
                setIsSubmitting(false);
                setData(x.data);
                setPrompts(x.data.prompts)
            })
        } catch (error) {
            console.error("Save failed", error);
            setIsSubmitting(false);
        }
    }

    const handleOpenSession =(e)=>{
        setIsSubmitting(true);
        try {
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("token"),
                    'Content-Type': 'application/json',
                }
            }
            const response = axios.post("/api/Ai/OpenSession",JSON.stringify({
                PromptId:id
            }), config);
            response.then(x => {
                setIsSubmitting(false);
                navigate("/ai/chat/"+x.data.id);
            })
        } catch (error) {
            console.error("Save failed", error);
            setIsSubmitting(false);
        }
    }
    
    return <>
        {loading ? (
            <SkeletonPopularCard/>
        ) : (
            <MainCard title={data.title}>
                <Typography variant="body2">
                    {data.description}
                </Typography>
                <MainCard>
                        <InputLabel htmlFor="outlined-adornment-prompt-login">Add Prompt</InputLabel>
                        <OutlinedInput
                            multiline={true}
                            rows={4}
                            style={{width:'100%'}}
                            id="outlined-adornment-prompt-login"
                            name="prompt"
                            onChange={(e)=>{
                                setPrompt(e.target.value);
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton sx={{mr:1}}
                                        aria-label="toggle prompt"
                                        onClick={()=>{
                                            const newPrompts = [...prompts, prompt];
                                            setPrompts(newPrompts);
                                        }}
                                        edge="end"
                                        size="large"
                                    >
                                        <Add/>
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="prompt"
                            inputProps={{}}
                        />
                </MainCard>
                
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {prompts.map((x, index) => (
                                    <Draggable key={index} draggableId={`draggable-${index}`} index={index}>
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <MainCard>
                                                    <InputLabel htmlFor={"outlined-adornment-prompt-login-" + index}>
                                                        Prompt {index + 1}
                                                    </InputLabel>
                                                    <OutlinedInput
                                                        multiline={true}
                                                        rows={4}
                                                        style={{ width: '100%' }}
                                                        id={"outlined-adornment-prompt-login-" + index}
                                                        value={x}
                                                        onChange={(e) => {
                                                            setPrompts((prevPrompts) => {
                                                                const updatedPrompts = [...prevPrompts];
                                                                updatedPrompts[index] = e.target.value;
                                                                return updatedPrompts;
                                                            });
                                                        }}
                                                        name="prompt"
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    sx={{ mr: 1 }}
                                                                    aria-label="toggle prompt visibility"
                                                                    onClick={() => {
                                                                        setPrompts((prevPrompts) =>
                                                                            prevPrompts.filter((_, i) => i !== index)
                                                                        );
                                                                    }}
                                                                    edge="end"
                                                                    size="large"
                                                                >
                                                                    <Delete />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        label="prompt"
                                                        inputProps={{}}
                                                    />
                                                </MainCard>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                <Grid container direction="row" justifyContent="between" spacing={2}>
                        <Box sx={{ m: 2, mt:5, width:120 }}>
                            <AnimateButton>
                                <Button disableElevation disabled={isSubmitting} fullWidth size="large" type="button" variant="contained" color="secondary" onClick={handleUpdate}>
                                    Update
                                </Button>
                            </AnimateButton>
                        </Box>
                    <Box sx={{ m: 2, mt:5, width:120 }}>
                        <AnimateButton>
                            <Button disableElevation disabled={prompts?.length===0 || isSubmitting} fullWidth size="large" type="button" variant="contained" color="primary" onClick={handleOpenSession}>
                                Try
                            </Button>
                        </AnimateButton>
                    </Box>          
                    </Grid>
            </MainCard>
        )}
    </>
}

export default PromptPage;
